/**
 * Small grey market tag (ANZ / USA) rendered as a prefix on every FP
 * reference across the DQ Workbench, so the market is legible at a glance
 * without reading the franchise name. One component = one consistent look.
 */
import React from 'react'
import { Chip } from '@mui/material'

interface Props {
  market?: string | null
}

const MarketChip: React.FC<Props> = ({ market }) => {
  if (!market) return null
  return (
    <Chip
      label={market}
      size="small"
      sx={{
        height: 18,
        fontSize: '0.65rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        bgcolor: 'grey.200',
        color: 'text.secondary',
        '& .MuiChip-label': { px: 0.75 },
      }}
    />
  )
}

export default MarketChip
